<template>
  <component :is="activeComponent"/>
</template>

<script>
  import MRootPharmacyOrders from "@/views/pharmacy-orders/m-root-pharmacy-orders-new";
  import DRootPharmacyOrders from "@/views/pharmacy-orders/d-root-pharmacy-orders-new";

  export default {
    name: "root-pharmacy-orders",
    computed: {
      activeComponent() {
        return this.$isDesktop ? DRootPharmacyOrders : MRootPharmacyOrders;
      }
    }
  }
</script>

<style scoped>

</style>